import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { DecksModule } from '../decks/decks.module';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '../common/common.module';
import { MatListModule } from '@angular/material/list';
import { CardsModule } from '../cards/cards.module';

@NgModule({
    declarations: [HomeComponent],
    imports: [
        NgCommonModule,
        RouterModule,
        MatSidenavModule,
        DecksModule,
        MatGridListModule,
        MatCardModule,
        CommonModule,
        MatListModule,
        CardsModule
    ]
})
export class HomeModule {}
